import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,26a9.27,9.27,0,0,0,9-9.5V2H23V16.5A7.27,7.27,0,0,1,16,24a7.27,7.27,0,0,1-7-7.5V2H7V16.5A9.27,9.27,0,0,0,16,26Z"/><rect x="4" y="28" width="24" height="2"/>';
export var TextUnderlinedOutlineSVG = function TextUnderlinedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextUnderlinedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextUnderlinedOutlineSVG);